import { List } from 'enchoice-fabric-react-lib';
import { SelectionMode } from 'office-ui-fabric-react';
import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { IRootState } from '../../redux/Reducers/RootReducer';
import './Payables.css';

function mapStateToProps(state: IRootState, ownProps: any) {
  return { username: state.securityState.security.username, loginMode: state.securityState.security.loginMode };
}

class Payables extends React.Component<any, any> {
  constructor(props: any) {
    super(props);

    this.isNull = this.isNull.bind(this);
    this.getUrl = this.getUrl.bind(this);
  }

  public render() {
    return (
      <div className="Payables">
        <List
          getUrl={this.getUrl}
          handleResponse={this.handleResponse}
          selectionMode={SelectionMode.none}
          enableSearch={false}
          enableSort={false}
          height={'800px'}
        />
      </div>
    );
  }

  private isNull(value: any) {
    return value === null || value === 'null' || value === undefined;
  }

  private handleResponse(items: any[]) {
    return items;
  }

  private getUrl(search: string, page: number, sortBy?: string | undefined, sortDesc?: boolean | undefined): string {
    const qValue = this.isNull(search) ? '' : `&q=${search}`;
    const sortByValue = this.isNull(sortBy) ? '' : `&_sort=${sortBy}`;
    let sortDescValue = '';

    if (!this.isNull(sortDesc)) {
      sortDescValue = sortDesc ? '&_order=desc' : '&_order=asc';
    }

    const url = `https://localhost:44300/api/documents?_start=${page}&_limit=20${qValue}${sortByValue}${sortDescValue}`;
    console.log(url);
    return url;
  }
}

export default withRouter(connect(
  mapStateToProps,
  null
)(Payables) as any);
